import { TabSwitcherVariation } from ".";
import { color as themeColor, colour } from "@styles";

export const variationColor = (variation: TabSwitcherVariation) => {
  switch (variation) {
    case "pink":
      return {
        background: themeColor.B210,
        tabBackground: themeColor.P10,
        blob: themeColor.P100,
        boxShadow: "8px 8px 0px #DFDFDD",
        border: themeColor.B2100,
        text: themeColor.B1100,
      };
    case "purple":
      return {
        background: themeColor.S310,
        tabBackground: themeColor.S320,
        blob: themeColor.S3100,
        boxShadow: "8px 8px 0px rgba(149,106,255,0.1)",
        border: themeColor.S3100,
        text: themeColor.S3100,
      };
  }
};
